"use client";

import { useSiteConfig } from "@/lib/SiteConfigContext";

// The homepage "why us" headline stats — CMS-configurable (value + label each,
// edited in the admin Photos tab). Reads from the live site config, which is
// seeded with the defaults so SSR/first paint match before the fetch resolves.
// Any stat left fully blank in the CMS is skipped so the row never shows an
// empty card.
export default function StatsRow() {
  const { stats } = useSiteConfig();
  const shown = stats.filter((s) => s.value || s.label);
  if (shown.length === 0) return null;

  return (
    <div className="flex gap-[14px]">
      {shown.map((st, i) => (
        <div key={`${st.label}-${i}`} className="flex-1 border-t-2 border-gold pt-[14px]">
          <div className="font-serif text-[44px] font-semibold leading-none text-gold-light">
            {st.value}
          </div>
          <div className="mt-2 text-xs leading-[1.5] text-slatey">{st.label}</div>
        </div>
      ))}
    </div>
  );
}
